module.exports = __webpack_public_path__ + "img/DE06211.8b147a16.png";